import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=f079ca04&scoped=true&lang=pug"
import script from "./TheSidebar.vue?vue&type=script&lang=ts"
export * from "./TheSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f079ca04",
  null
  
)

export default component.exports